import React, { FC } from 'react'
import { SvgIcon } from '../../shared/SvgIcon'
import { SvgType } from '../../shared/SvgIcon/SvgIcon'
import { AbstractEmailButton } from './styled'

interface AbstractEmailProps {
  email: string
}

export const AbstractEmail: FC<AbstractEmailProps> = ({ email }) => {
  const triggerMailto = () => {
    window.open(`mailto:${email}`, '_blank')
  }

  return (
    <AbstractEmailButton onClick={triggerMailto}>
      <SvgIcon type={SvgType.SEND_EMAIL} />
      <p>Ask Presenter Questions</p>
      {/* <p className="email">{email}</p> */}
      <p className="email">Email Presenter</p>
    </AbstractEmailButton>
  )
}
